import { memo } from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CAMPAIGN_STATUS_ENUM } from 'modules/campaigns/constants/common/status.enum';

type Props = {
  value: CAMPAIGN_STATUS_ENUM;
  className?: string;
};

const STATUS_COLORS = {
  [CAMPAIGN_STATUS_ENUM.CREATED]: {
    backgroundColor: '#000000', // black
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.WAITING_PAY]: {
    backgroundColor: '#ff9800', // orange - waiting for payment
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.IN_PROGRESS]: {
    backgroundColor: '#2196f3', // blue - actively running
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.REVIEW]: {
    backgroundColor: '#9c27b0', // purple - under review
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.ACCEPTED]: {
    backgroundColor: '#d3c052', // golden yellow - accepted from theme
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.PAID]: {
    backgroundColor: '#2e7d32', // green - success
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.COMPLETED]: {
    backgroundColor: '#4caf50', // bright green - happy completion
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.ERROR_PAY]: {
    backgroundColor: '#d32f2f', // red - error
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.FAILED]: {
    backgroundColor: '#d32f2f', // red - failure
    color: 'white',
  },
  [CAMPAIGN_STATUS_ENUM.CANCELLED]: {
    backgroundColor: '#d32f2f', // error
    color: 'white',
  },
};

const CampaignStatus = ({ value, className }: Props) => {
  const { t } = useTranslation('campaigns');
  return (
    <Chip
      label={t(`status.${value}`)}
      size={'small'}
      className={className}
      variant={'filled'}
      sx={{
        px: 0.5,
        ...STATUS_COLORS[value]
      }}
    />
  );
};

export default memo(CampaignStatus);
